import styled from 'styled-components';

export const SzeryfDesktop = styled.div`
	width: 120px;

	img {
		width: 100%;
		height: auto;
	}

	@media (max-width: 600px) {
		display: none;
	}
`;
export const PlanWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 18px;
	margin-top: 8px;
	width: 360px;

	@media (min-width: 600px) {
		width: 660px;
	}
	z-index: 999;
`;

export const Title = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 120%; /* 19.2px */

	margin-top: 4px;
`;
export const Months = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 19.2px */
`;
export const FullPrice = styled.div`
	color: var(--Text-color, #29185e);
	font-family: 'Work Sans';
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 16.8px */
	min-height: 12px;
	margin-top: 24px;
`;

export const PromoPrice = styled.div`
	color: #0fa831;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 140%; /* 22.4px */

	margin-top: 4px;
`;

export const ImageWrapper = styled.div`
	width: 140px;
	position: relative;

	img {
		width: 100%;
		height: auto;
	}

	div {
		position: absolute;
		bottom: 9px;

		color: #fff;
		font-family: 'Work Sans';
		font-size: 11px;
		font-style: normal;
		font-weight: 400;
		line-height: 120%; /* 13.2px */
		width: 100%;
		text-align: center;
	}

	@media (min-width: 600px) {
		width: 160px;
	}
`;

export const TextInformationWrapper = styled.div`
	max-width: 180px;
`;
